import { TelegramClient } from 'messaging-api-telegram';
import config from 'error-handler/config';
import { ParseMode } from 'messaging-api-telegram/dist/TelegramTypes';

type Chat = 'error' | 'cargoes';
interface ISendObj {
  label: string;
  value: string;
}

import axios from 'axios';

export default class Telegram {
  private readonly BOT_ID?: string;
  private readonly CHAT_ID?: string;

  constructor(type: Chat) {
    this.BOT_ID = type === 'error' ? config.TELEGRAM_TOKEN : process.env.TELEGRAM_TOKEN_CARGOES;
    this.CHAT_ID = type === 'error' ? config.DFA_LOGS_ID : process.env.CARGOES_CHAT_ID;
  }

  async send(content: string) {
    if (content === '{}') return;

    const escapeMarkdown = (text: string) =>
      text.trim().replace(/[_[\]()~#+\-={}.!]/g, '\\$&');

    const url = `https://api.telegram.org/bot${this.BOT_ID}/sendMessage`;
    const response = await axios.post(url, {
      chat_id: this.CHAT_ID,
      text: escapeMarkdown(content),
      parse_mode: 'MarkdownV2',
    });
    return response.data;
  }

  async sendObj(content: ISendObj[], title?: string) {
    const html: string =
      (title ? `**[${title}]**` : '') +
      content.map((item: ISendObj) => `**${item.label}** ${item.value}`).join('\n');
    await this.send(html);
  }
}
